import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3" }
const _hoisted_2 = { class: "card-body p-0" }
const _hoisted_3 = { class: "d-flex justify-content-between align-items-center flex-wrap gap-2 p-4" }
const _hoisted_4 = {
  class: "dropdown action-opt",
  style: {"right":"-1px"}
}
const _hoisted_5 = { class: "dropdown-menu dropdown-menu-end bg-white border box-shadow" }
const _hoisted_6 = { class: "default-table-area style-two transactions-history" }
const _hoisted_7 = { class: "table-responsive" }
const _hoisted_8 = { class: "table align-middle" }
const _hoisted_9 = { class: "text-body" }
const _hoisted_10 = {
  class: "d-flex align-items-center",
  style: {"gap":"8px"}
}
const _hoisted_11 = ["src", "alt"]
const _hoisted_12 = { class: "fw-medium text-secondary fs-13" }
const _hoisted_13 = { class: "fw-normal fs-12 text-body" }
const _hoisted_14 = { class: "text-center" }
const _hoisted_15 = { class: "text-body text-end fs-13" }
const _hoisted_16 = {
  class: "d-flex justify-content-center justify-content-sm-between align-items-center text-center flex-wrap gap-2 showing-wrap p-4",
  style: {"padding-top":"15px !important"}
}
const _hoisted_17 = { class: "fs-13" }
const _hoisted_18 = { "aria-label": "Page navigation example" }
const _hoisted_19 = { class: "pagination mb-0 justify-content-center" }
const _hoisted_20 = { class: "page-item" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "page-item" }
const _hoisted_24 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[8] || (_cache[8] = _createElementVNode("h5", { class: "mb-0" }, "Transactions History", -1)),
        _createElementVNode("div", _hoisted_4, [
          _cache[7] || (_cache[7] = _createElementVNode("button", {
            class: "btn bg-transparent p-0",
            type: "button",
            "data-bs-toggle": "dropdown",
            "aria-expanded": "false"
          }, [
            _createElementVNode("i", { class: "ri-more-fill fs-26 text-body lh-1" })
          ], -1)),
          _createElementVNode("ul", _hoisted_5, [
            _createElementVNode("li", null, [
              _createElementVNode("button", {
                class: "dropdown-item",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.filterByTime('day')))
              }, " This Day ")
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("button", {
                class: "dropdown-item",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.filterByTime('week')))
              }, " This Week ")
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("button", {
                class: "dropdown-item",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.filterByTime('month')))
              }, " This Month ")
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("button", {
                class: "dropdown-item",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.filterByTime('year')))
              }, " This Year ")
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("button", {
                class: "dropdown-item",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.resetFilters && _ctx.resetFilters(...args)))
              }, " All Time ")
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("table", _hoisted_8, [
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginatedTransactions, (transaction) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: transaction.id
                }, [
                  _createElementVNode("td", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("img", {
                        src: _ctx.getImagePath(transaction.currency),
                        style: {"max-width":"22px"},
                        alt: transaction.currency
                      }, null, 8, _hoisted_11),
                      _createElementVNode("span", _hoisted_12, [
                        _createTextVNode(_toDisplayString(transaction.name) + " ", 1),
                        _createElementVNode("span", _hoisted_13, " (" + _toDisplayString(transaction.symbol) + ") ", 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_14, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["d-inline-block rounded-1 fs-12 fw-medium", _ctx.getStatusClass(transaction.status)]),
                      style: {"padding":"2px 8px"}
                    }, _toDisplayString(transaction.status), 3)
                  ]),
                  _createElementVNode("td", _hoisted_15, " $" + _toDisplayString(_ctx.formatAmount(transaction.amount)), 1)
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("span", _hoisted_17, " Showing " + _toDisplayString(_ctx.showingRange) + " of " + _toDisplayString(_ctx.filteredTransactions.length) + " results ", 1),
          _createElementVNode("nav", _hoisted_18, [
            _createElementVNode("ul", _hoisted_19, [
              _createElementVNode("li", _hoisted_20, [
                _createElementVNode("button", {
                  class: "page-link icon hover-bg",
                  "aria-label": "Previous",
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args))),
                  disabled: _ctx.currentPage === 1
                }, [...(_cache[9] || (_cache[9] = [
                  _createElementVNode("i", { class: "material-symbols-outlined" }, "keyboard_arrow_left", -1)
                ]))], 8, _hoisted_21)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.totalPages, (page) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "page-item",
                  key: page
                }, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["page-link", { active: _ctx.currentPage === page }]),
                    onClick: ($event: any) => (_ctx.goToPage(page))
                  }, _toDisplayString(page), 11, _hoisted_22)
                ]))
              }), 128)),
              _createElementVNode("li", _hoisted_23, [
                _createElementVNode("button", {
                  class: "page-link icon hover-bg",
                  "aria-label": "Next",
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args))),
                  disabled: _ctx.currentPage === _ctx.totalPages
                }, [...(_cache[10] || (_cache[10] = [
                  _createElementVNode("i", { class: "material-symbols-outlined" }, "keyboard_arrow_right", -1)
                ]))], 8, _hoisted_24)
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}